import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../store/store';
import { getIsBitSet, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import {
    getIsBitSet as getIsSearchBitSet,
    SearchBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/searchBitFlagsUtil';
import { isFeatureEnabled } from 'owa-feature-flags';

export function isSearchResultsOptionDirty() {
    return (
        isSearchDeletedItemOptionDirty() ||
        (isFeatureEnabled('sea-inboxScopeSetting') && isDefaultFolderScopeOptionDirty())
    );
}

export function isDefaultFolderScopeOptionDirty() {
    const scopeInboxSearchToFolderStateOption = getIsSearchBitSet(
        SearchBitFlagsMasks.ScopeInboxSearchToFolder
    );
    const scopeInboxSearchToFolder = getFallbackValueIfNull(
        getStore().scopeToInboxFolder,
        scopeInboxSearchToFolderStateOption
    );
    return scopeInboxSearchToFolder !== scopeInboxSearchToFolderStateOption;
}

export function isSearchDeletedItemOptionDirty() {
    const excludeDeletedItemsInSearchViewStateOption = getIsBitSet(
        ListViewBitFlagsMasks.ExcludeDeletedItemsInSearch
    );
    const excludeDeletedItemsInSearch = getFallbackValueIfNull(
        getStore().excludeDeletedItemsInSearch,
        excludeDeletedItemsInSearchViewStateOption
    );
    return excludeDeletedItemsInSearch !== excludeDeletedItemsInSearchViewStateOption;
}
